import { render, staticRenderFns } from "./download-center-child-table.component.vue?vue&type=template&id=4b8e5d9b&scoped=true&"
import script from "./download-center-child-table.component.vue?vue&type=script&lang=tsx&"
export * from "./download-center-child-table.component.vue?vue&type=script&lang=tsx&"
import style0 from "./download-center-child-table.component.vue?vue&type=style&index=0&id=4b8e5d9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8e5d9b",
  null
  
)

export default component.exports